export type LanguageCode = "sr-Latn" | "sr-Cyrl" | "en" | "bs" | "hr" | "mk" | "hu" | "sk" | "sl" | "ro" | "rue";

export const DEFAULT_LANGUAGE: LanguageCode = "sr-Latn";

export interface LanguageMeta {
  code: LanguageCode;
  /** For document.documentElement.lang. */
  bcp47Tag: string;
  /** Short label shown on the dropdown trigger/menu. */
  abbrev: string;
  /** Emoji flag, or a neutral icon for languages with no ISO country flag. */
  flag: string;
  /** Always shown in the language's own script/spelling — never routed through t(). */
  nativeName: string;
}

export const LANGUAGES: LanguageMeta[] = [
  { code: "sr-Latn", bcp47Tag: "sr-Latn", abbrev: "SR", flag: "🇷🇸", nativeName: "Srpski (latinica)" },
  { code: "sr-Cyrl", bcp47Tag: "sr-Cyrl", abbrev: "СР", flag: "🇷🇸", nativeName: "Српски (ћирилица)" },
  { code: "en", bcp47Tag: "en", abbrev: "EN", flag: "🇬🇧", nativeName: "English" },
  { code: "bs", bcp47Tag: "bs", abbrev: "BS", flag: "🇧🇦", nativeName: "Bosanski" },
  { code: "hr", bcp47Tag: "hr", abbrev: "HR", flag: "🇭🇷", nativeName: "Hrvatski" },
  { code: "mk", bcp47Tag: "mk", abbrev: "MK", flag: "🇲🇰", nativeName: "Македонски" },
  { code: "hu", bcp47Tag: "hu", abbrev: "HU", flag: "🇭🇺", nativeName: "Magyar" },
  { code: "sk", bcp47Tag: "sk", abbrev: "SK", flag: "🇸🇰", nativeName: "Slovenčina" },
  { code: "sl", bcp47Tag: "sl", abbrev: "SL", flag: "🇸🇮", nativeName: "Slovenščina" },
  { code: "ro", bcp47Tag: "ro", abbrev: "RO", flag: "🇷🇴", nativeName: "Română" },
  { code: "rue", bcp47Tag: "rsk", abbrev: "RUE", flag: "🌐", nativeName: "Руски язик" },
];

export function isLanguageCode(value: string): value is LanguageCode {
  return LANGUAGES.some((l) => l.code === value);
}
